import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

import { BORDER_RADIUS, NEUTRAL_MID_COLOR } from "../constants";

export const MenuPaper = styled(Paper)(() => ({
  marginTop: "10px",
  marginBottom: "10px",
  maxHeight: 300,
  overflow: "auto",
  border: "none",
  boxShadow: "0px 4px 4px 0px #00000040",
  borderRadius: BORDER_RADIUS,

  // Custom scrollbar styles
  "&::-webkit-scrollbar": {
    width: "5px", // Width of the scrollbar
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F2F5F6", // Track color
    borderRadius: "100px", // Fully rounded track
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#C8CDD3", // Thumb color
    borderRadius: "100px", // Fully rounded thumb
    border: "none", // Adjust border for smaller width
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: NEUTRAL_MID_COLOR, // Darker thumb on hover
  },
}));
